import { userConstants } from "../../constants/ActionTypes";

const initialState = {
    apikeys:{},
    whitelist_ip: [],
    isapikeys:false,
    modalIsOpen:false,
    add_ip:"",
    bankAccountCredit:"",
    connectBankVACredit:"",
    virtualAccountCredit:"",
    invalidUPICredit:"",
    bankAccountVerify:"",
    invalidVACredit:"",
    upiIdVerify:"",
    fundTransfer:"",
    fundTransferStatus:"",
    upiCollectStatus:"",
    lowBalance:"",
    status:"",
    isWebhookUrl:false,
    isShowEditWebhoolUrl:false,
    webhookDetail:{},
    editbankAccountCredit:"",
    editconnectBankVACredit:"",
    editvirtualAccountCredit:"",
    editinvalidUPICredit:"",
    editbankAccountVerify:"",
    editinvalidVACredit:"",
    editupiIdVerify:"",
    editfundTransfer:"",
    editfundTransferStatus:"",
    editupiCollectStatus:"",
    editlowBalance:"",



};

export function api_details(state = initialState, action) {
    switch (action.type) {  
        case userConstants.API_DETAILS:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}